import { frontendURL } from '../../helper/URLHelper';
import TasksIndex from './Index.vue';

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tasks'),
    name: 'tasks_view',
    component: TasksIndex,
    meta: commonMeta,
  },
];
